
import React from 'react';
import { AppProviders } from '@/components/app/AppProviders';
import { AppContent } from '@/components/app/AppContent';
import { JSXErrorBoundary } from '@/components/JSXErrorBoundary';
import './App.css';

function App() {
  console.log('🚀 App component rendering...');
  
  return (
    <JSXErrorBoundary>
      <AppProviders>
        <AppContent />
      </AppProviders>
    </JSXErrorBoundary>
  );
}

export default App;
